'use strict';

(function (global) {

  // Css-классы
  const baseCssClass = 'preview-container';
  const iframeCssClassHidden = `${baseCssClass}__content_hidden`;
  const overlayCssClass = `${baseCssClass}__overlay`;
  const overlayCssClassHidden = `${overlayCssClass}_hidden`;

  // Селекторы
  const iframeSelector = '#contentContainer';
  const overlaySelector = `.${overlayCssClass}`;

  /**
   * Предпросмотр документа.
   *
   * @hideconstructor
   * @since 5.7.0
   */
  class Preview {

    /**
     * Проинициализировать предпросмотр
     *
     * @method init
     * @param {object} context Модель данных предпросмотра, приходящая с сервера.
     */
    init(context) {
      this.context = context;

      this._jContainer = $(`#${context.wrapperId}`);
      this._jFrame = $(iframeSelector);

      this._urlHandler = context.previewHandlerUrl;

      const documentData = context.convertedObj;

      const dataType = new window.Core.preview.DataType(
        context.objectsData[context.selectedObj.id].dataType,
        documentData.isImage,
        documentData.pageCount
      );

      this.document = {
        convertedObjId: documentData.id,
        dataType: dataType,
        pageCount: documentData.pageCount,
        pageNumber: 1,
        versionId: context.versionsId,
      };

      this._documentHeadFile = {
        css: documentData.cssLink,
        js: documentData.scriptFileName,
      };

      window.Core.preview.toolbar.init();
      this._setToolbarControlsVisibility();

      if (context.errorMessage) {
        this.showError(context.errorMessage, context.errorType);
        // Прячем блок, экранирующий область предпросмотра (тулбар предпросмотра и iframe с загруженным документом)
        this._hideOverlay();
      } else {
        if (documentData.isImage) {
          this._showOverlay();
          this._drawFirstPageInCanvas().done(() => { this._onFrameLoad(); });
        } else {
          this._jFrame.on('load', () => this._onFrameLoad());

          this._loadFrame();
        }
      }

      $(window).bind('resize', 'orientationchange', () => {
        if (window.Core.preview.actions) {
          window.Core.preview.actions.onResize();
        }
      });
    }

    /**
     * Загрузить версию документа для предпросмотра
     *
     * @method setVersion
     * @param {string} versionId Идентификатор версии.
     */
    setVersion(versionId) {
      this._showOverlay();
      const url = new WA.URL();
      const pluginName = (url.getParam('plugin')) ? url.getParam('plugin').toLowerCase() : url.getParam('convertPlugin').toLowerCase();

      $.ajax({
        type: 'GET',
        url: this._urlHandler,
        data: {
          id: versionId,
          plugin: pluginName,
        },
        cache: false,
        dataType: 'json',

        success: (data) => {
          this.hideError();

          const dataType = new window.Core.preview.DataType(
            this.context.objectsData[versionId].dataType,
            data.IsImage,
            data.PageCount
          );

          this.document = {
            convertedObjId: data.Id,
            dataType: dataType,
            pageCount: data.PageCount,
            pageNumber: 1,
            versionId: versionId,
          };

          // TODO: в будущем хорошо бы отказаться от объекта context в таком виде
          const context = window.Core.preview.context;
          context.convertedObj.pageCount = this.document.pageCount;
          context.convertedObj.id = this.document.convertedObjId;
          context.convertedObj.docExtension = data.DocExtension;
          context.convertedObj.cssLink = data.AttachedStylesFileName;
          context.convertedObj.scriptFileName = data.AttachedScriptFileName;
          context.convertedObj.isImage = data.IsImage;
          context.selectedObj.id = this.document.versionId;

          this._setToolbarControlsVisibility();
          Core.preview.toolbar.initScaleInputValues();

          this.init(context);
        },

        error: (response) => {
          const msg = JSON.parse(response.responseText);
          this.showError(msg.error, msg.errorType);

          this._hideOverlay();
        }

      });
    }

    /**
     * Загрузить документ в iframe.
     *
     * @method _loadFrame
     * @private
     */
    _loadFrame() {
      const frameSrc = `${this._urlHandler}/${this.document.convertedObjId}/1`;
      this._jFrame
        .attr('src', frameSrc)
        .addClass(iframeCssClassHidden);
    }

  /**
   * Отрисовать первую страницу в canvas.
   *
   * @method _drawFirstPageInCanvas
   * @private
   */
    _drawFirstPageInCanvas() {
      const d = $.Deferred();
            
      this._jFrame[0].contentDocument.body.innerHTML = '<canvas id="page_1"></canvas>';
      this._drawImageInCanvas(1, 'N', 1).done(() => { d.resolve(this); });

      return d.promise();
    }

    /**
     * Загрузить картинку в canvas.
     * 
     * @method _drawImageInCanvas
     * @param {any} pageNum Номер страницы.
     * @param {any} direction Направление поворота.
     * @param {any} scale Масштаб.
     * @param {any} forceLoad Принудительная загрузка изображения.
     */
    _drawImageInCanvas(pageNum, direction = 'N', givenScale = 1, forceLoad = false) {
      let img = new Image();
      const d = $.Deferred();
      let shouldFlipHeightAndWidth = (direction === 'W' || direction === 'E');
      let jCanvas = $(`#page_${pageNum}`, $('#contentContainer')[0].contentDocument);

      img.onload = (() => {
        let scale = (Core && Core.preview.actions ? Core.preview.actions._scale : givenScale);
        if (!scale || typeof (scale) === 'NaN') {
          scale = 1;
        }
        let canvas = jCanvas[0];
        if (canvas) {
          let ctx = canvas.getContext('2d');

          let h = shouldFlipHeightAndWidth ? img.naturalWidth * scale : img.naturalHeight * scale;
          let w = shouldFlipHeightAndWidth ? img.naturalHeight * scale : img.naturalWidth * scale;

          canvas.width = w;
          canvas.height = h;

          ctx.clearRect(0, 0, canvas.height, canvas.width);
          ctx.save();

          // context.setTransform(a, b, c, d, e, f);
          // a	Горизонтальный масштаб
          // b	Горизонтальное скручивание
          // c	Вертикальное скручивание
          // d	Вертикальный масштаб
          // e	Горизонтальный сдвиг
          // f	Вертикальный сдвиг
          ctx.setTransform(scale, 0, 0, scale, w / 2, h / 2);

          let degrees = 0;
          switch (direction) {
            case 'E': {
              degrees = 90; break;
            }
            case 'S': {
              degrees = 180; break;
            }
            case 'W': {
              degrees = 270; break;
            }
            case 'N':
            default: {
              degrees = 0;
              break;
            }
          }
          ctx.rotate(degrees * Math.PI / 180);

          ctx.drawImage(img, -img.width / 2, -img.height / 2);
          ctx.restore();

          canvas.setAttribute('naturalHeight', img.naturalHeight);
          canvas.setAttribute('naturalWidth', img.naturalWidth);
          canvas.setAttribute('src', img.src);
          jCanvas.removeClass('invisible');
          jCanvas.addClass('previewImage');
          jCanvas.attr('data-pagenumber', pageNum);

          if (WA.ENV.browser.name === 'IE') {
            jCanvas.parent('.placeholder').width(w).height(h);
          }
        }
        d.resolve(this);
      });

      if (forceLoad || !jCanvas.attr('src')) {
        img.src = `${Core.preview._urlHandler}/${Core.preview.document.convertedObjId}/${pageNum}`;
      }
      else {
        d.resolve();
      }
      return d.promise();
    }

    /**
     * Преобразовать документ после его загрузки в iframe.
     *
     * @method _prepareFreshlyLoadedDocument
     * @private
     * @return {Promise<void>}
     */
    _prepareFreshlyLoadedDocument() {
      let postprocessor;
      const docType = this.document.dataType;
      if (docType.isText) {
        if (docType.wasMadeFromMsWordDocument) {
          postprocessor = window.Core.preview.WordDocumentPostprocessor;
        } else {
          postprocessor = window.Core.preview.BaseDocumentPostprocessor;
        }
      } else if (docType.isSpreadsheet) {
        postprocessor = window.Core.preview.ExcelDocumentPostprocessor;
      } else if (docType.isImage) {
          postprocessor = window.Core.preview.ImageDocumentPostprocessor;
      }

      return postprocessor.prepare(this._jFrame, this._documentHeadFile, this.document.dataType._extension);
    }

    /**
     * Устанавливает необходимые действия в зависимости от типа документа.
     *
     * @method _getAppropriatePreviewActions
     * @private
     * @return {class} Класс действий предпросмотра, наследуемый от window.Core.preview.BaseActions
     */
    _getAppropriatePreviewActions() {
      const docType = this.document.dataType;
      if (docType.isText) {
        if (docType.wasMadeFromMsWordDocument) {
          return new window.Core.preview.WordDocumentActions(this.context);
        } else {
          return new window.Core.preview.TextActions(this.context);
        }

      } else if (docType.isSpreadsheet) {
        return new window.Core.preview.SpreadsheetActions(this.context);

      } else if (docType.isImage) {
        return new window.Core.preview.ImageActions(this.context);
      }
    }

    /**
     * Скрыть или показать контролы тулбара предпросмотра в зависимости от типа документа.
     *
     * @method _setToolbarControlsVisibility
     * @private
     */
    _setToolbarControlsVisibility() {
      const docType = this.document.dataType;
      const toolbar = window.Core.preview.toolbar;
      const toolbarControls = toolbar.controls;

      if (docType.isImage || docType.isScalable) {
        toolbarControls.fitToButtons.show();
        toolbarControls.scale.show();
        toolbarControls.rotateButtons.show();
      } else {
        toolbarControls.fitToButtons.hide();
        toolbarControls.scale.hide();
        toolbarControls.rotateButtons.hide();
      }

      if (docType.isText) {
        toolbarControls.fitToButtons.hide();
        toolbarControls.rotateButtons.hide();
      }

      if (docType.isMultipage) {
        toolbarControls.pagination.show();
        toolbar.updatePaginator(this.document.pageCount);
      } else {
        toolbarControls.pagination.hide();
      }

      if (docType.wasMadeFromMsWordDocument) {
        toolbarControls.wordButtons.show();
      } else {
        toolbarControls.wordButtons.hide();
      }
    }

    /**
     * Произвести действия над предпросмотром после его загрузки в iframe.
     *
     * @method _onFrameLoad
     * @private
     */
    _onFrameLoad() {
      this._prepareFreshlyLoadedDocument().then(() => {
        this._setToolbarControlsVisibility();
        window.Core.preview.actions = this._getAppropriatePreviewActions();
        if (!this.document.dataType.isImage) {
          window.Core.preview.actions.setScale();
        }

        if (this.document.dataType.isText && this.document.dataType.wasMadeFromMsWordDocument) {
          const toolbarButtons = window.Core.preview.toolbar.buttons;
          toolbarButtons.enableChangeTrack.setSelectedStateAndPerformAction(window.Core.preview.actions.settings.trackChangesVisibility);
          toolbarButtons.enableComments.setSelectedStateAndPerformAction(window.Core.preview.actions.settings.commentsVisibility);
        }

        if (!this.document.dataType.isImage) {
          this.dispatchFrameReadyEvent();
          // Прячем блок, экранирующий область предпросмотра (тулбар предпросмотра и iframe с загруженным документом)
          this._hideOverlay();
        }
      });
    }

    /**
     * Отобразить блок, экранирующий область предпросмотра.
     * Используется во время загрузки содержимого предпросмотра, чтобы пользователь не трогал контролы раньше времени.
     *
     * @method _showOverlay
     * @private
     */
    _showOverlay() {
      const jOverlay = this._jContainer.find(overlaySelector);
      jOverlay.removeClass(overlayCssClassHidden);
    }

    /**
     * Спрятать блок, экранирующий область предпросмотра.
     *
     * @method _hideOverlay
     * @private
     */
    _hideOverlay() {
      // Показываем iframe (с сервера он пришёл к нам спрятанным, чтобы у пользователя не мелькало масштабирование)
      this._jFrame.removeClass(iframeCssClassHidden);

      const jOverlay = this._jContainer.find(overlaySelector);
      jOverlay.addClass(overlayCssClassHidden);
    }

    /**
     * Показать сообщение об ошибке.
     *
     * @method showError
     * @param {string} errorMsg Сообщение об ошибке.
     * @param {string} errorType Тип сообщения (ошибка/предупреждение).
     */
    showError(errorMsg, errorType) {
      $.when(WA.FormControlsInit).then(() => {
        WA.CMP.NTF.InlineHint.hideAll();
        const inlineHintParams = {
          type: (errorType === 'error') ? MESSAGE_TYPE.ERROR : MESSAGE_TYPE.WARNING,
          priority: INLINE_HINT_PRIORITY.PRIMARY,
        };
        WA.CR.inlineHint.show(errorMsg, inlineHintParams);
      });
    }

    /**
     * Спрятать сообщения об ошибке.
     *
     * @method hideError
     */
    hideError() {
      $.when(WA.FormControlsInit).then(() => {
        WA.CR.inlineHint.hide();
      });
    }

    /**
     * Отправить событие готовности фрейма.
     * 
     * @method dispatchFrameReadyEvent
     * */
    dispatchFrameReadyEvent() {
      let event = document.createEvent('CustomEvent');
      event.initCustomEvent('ready', false, false, this._jFrame[0]);
      this._jFrame[0].dispatchEvent(event);
    }

  }

  global.preview = new Preview();

})(window.Core);
